var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashIcon = function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.797 6.521a.422.422 0 0 0-.422.422v7.967a.422.422 0 0 0 .843 0V6.943a.422.422 0 0 0-.421-.422ZM4.822 6.521a.422.422 0 0 0-.421.422v7.967a.422.422 0 0 0 .843 0V6.943a.422.422 0 0 0-.422-.422Z",
    fill: "#555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.197 5.359v10.386c0 .614.225 1.19.619 1.604.391.415.936.65 1.506.651h7.975a2.075 2.075 0 0 0 1.507-.651c.393-.414.618-.99.618-1.604V5.359a1.61 1.61 0 0 0-.413-3.167H10.85v-.527A1.656 1.656 0 0 0 9.18 0H5.438a1.656 1.656 0 0 0-1.67 1.665v.527H1.61a1.61 1.61 0 0 0-.413 3.167Zm10.1 11.798H3.322c-.721 0-1.282-.62-1.282-1.412V5.395H12.58v10.35c0 .793-.56 1.412-1.282 1.412ZM4.612 1.665a.812.812 0 0 1 .826-.822h3.743a.812.812 0 0 1 .827.822v.527H4.612v-.527ZM1.61 3.035H13.01a.759.759 0 1 1 0 1.518H1.61a.759.759 0 1 1 0-1.518Z",
    fill: "#555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31 6.521a.422.422 0 0 0-.422.422v7.967a.422.422 0 0 0 .843 0V6.943a.422.422 0 0 0-.421-.422Z",
    fill: "#555"
  })));
};
export default SvgTrashIcon;